export const INVENTORY_VARIANCE_PERMISSION = "InventoryVariance";
export const INVENTORY_COUNTING_PERMISSION = "BeginningEndingInventory";
export const INVENTORY_MANAGEMENT_PERMISSION = "InventoryManagement";
export const INVENTORY_RESTOCK_PERMISSION = "RestockOnly";

const getModuleName = (module) =>
  module?.name || module?.module || (typeof module === "string" ? module : "");

const hasModule = (user, moduleName) =>
  (user?.modules || []).some((module) => getModuleName(module) === moduleName);

export const canViewInventoryVariance = (user) =>
  String(user?.role || "").toLowerCase() === "superadmin" ||
  hasModule(user, INVENTORY_VARIANCE_PERMISSION);

export const canManageInventory = (user) =>
  String(user?.role || "").toLowerCase() === "superadmin" ||
  hasModule(user, INVENTORY_MANAGEMENT_PERMISSION);

export const canCountInventory = (user) =>
  canManageInventory(user) || hasModule(user, INVENTORY_COUNTING_PERMISSION);

export const canRestockInventory = (user) =>
  canManageInventory(user) || hasModule(user, INVENTORY_RESTOCK_PERMISSION);
